import React from 'react'
import {
  Box,
  Grid,
  Chip,
  Input,
  Select,
  Checkbox,
  MenuItem,
} from '@material-ui/core'
import classNames from 'classnames'
import { Stack, Typography } from '@mui/material'
import { Controller } from 'react-hook-form'
import { TimePicker } from './form/DateTimePicker'
import { TextField } from './form/TextField'
import { LocationSelector } from './form/LocationSelector'
import Visibility from '@material-ui/icons/Visibility'
import VisibilityOff from '@material-ui/icons/VisibilityOff'
import IconButton from '@material-ui/core/IconButton'
import InputAdornment from '@material-ui/core/InputAdornment'
import { GalleryFormFieldLabel } from './GalleryFormFieldLabel'


export const GalleryPasswordFormField = ({
  control,
  classes,
  MenuClass,
  formProps,
  showPassword,
  setShowPassword,
  openSports,
  activityTags,
  setOpenSports,
  selectedGallery,
  activity_tag_options,
  handleActivityTagChange
}) => {


  const inputStyling = {
    padding: '0px 10px',
    background: '#ebebeb',
    width: 249,
    height: 25,
    fontWeight: 400,
    fontSize: 12,
    color: '#606060',
    '& input': {
      width: '100%'
    }
  }

  const handleShowPassword = () => setShowPassword((val) => !val)
  
  return (
    <Grid item xs={12}>
      <Box sx={{ display: 'flex', gap: '10px'}}>
        <GalleryFormFieldLabel label='Password'/>
        <span id='passwordFieldWrapper'>
        <Typography sx={inputStyling}>
          <Controller
            name='gallery_password'
            control={control}
            render={(fieldProps) => (
              <TextField
                fieldProps={fieldProps}
                type={showPassword ? 'text' : 'password'}
                autoComplete='new-password'
                variant='standard'
                disableUnderline
                InputProps={{
                  endAdornment: (
                    <InputAdornment position='end' sx={{display: 'none'}}>
                      <IconButton
                        aria-label='toggle password visibility'
                        onClick={handleShowPassword}
                      >
                        {showPassword ? (
                          <Visibility className={classes.gallery_password_visibility_icon} />
                        ) : (
                          <VisibilityOff className={classes.gallery_password_visibility_icon} />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                placeholder='Enter if Applicable'

                />
            )}
          />
    </Typography>
        </span> 
      </Box>
    </Grid>
  )
}
